import Button from '../../atoms/Button/Button';
import styles from './LowTimeModal.module.scss';

/**
 * CPAYMENT-1731: попап «времени почти не осталось» в DefaultTemplate.
 *
 * Клиент, ушедший в приложение банка за чеком, на таймер не смотрит — и возвращается к истёкшему
 * тикету с уже переведёнными деньгами. Кнопка ведёт туда же, куда «Я оплатил»: отметка «клиент
 * платит» продлевает окно, страница открывает загрузку чека.
 *
 * Текст русский без i18n — правило шаблона (локализован только Pinco).
 */
const LowTimeModal = ({
  onExtend,
  onDismiss,
}: {
  onExtend: () => void;
  onDismiss: () => void;
}) => (
  <div className={styles.overlay} onClick={onDismiss}>
    <div className={styles.box} onClick={(e) => e.stopPropagation()}>
      <p className={styles.title}>Времени на оплату почти не осталось</p>
      <p className={styles.text}>
        {'Если вы уже перевели деньги или переводите их сейчас — нажмите «Мне нужно ещё время», и мы продлим оплату, а затем попросим загрузить чек.'}
      </p>
      <div className={styles.actions}>
        <Button variant='primary' onClick={onExtend} dataSentryElement='extend-time'>
          Мне нужно ещё время
        </Button>
        <button
          type='button'
          className={styles.stay}
          onClick={onDismiss}
          data-sentry-element='low-time-dismiss'
        >
          Закрыть
        </button>
      </div>
    </div>
  </div>
);

export default LowTimeModal;
